export const MSG_UPLOAD = {
    INITIAL: (fn) => (fn("UPLOAD_FILE__MESSAGE_INITIAL")),
    SAVING: (fn , total = null) => (total ? `${fn("UPLOAD_FILE__MESSAGE_SAVING")} (${total} file)` : fn("UPLOAD_FILE__MESSAGE_SAVING")),
    SUCCESS: (fn, total = 0) => (`${total} file ${fn("UPLOAD_FILE__MESSAGE_SUCCESS")}`),
    FAILED: (fn) => (fn("UPLOAD_FILE__MESSAGE_FAILED")),
    READY: (fn, total = 0) => (`${total} file ${fn('UPLOAD_FILE__MESSAGE_READY')}`)
}